// WARNING: This file is automatically generated!
import enCommon from '../localization/en/common.json';
import enPageAppointmentReserved from '../localization/en/page.appointment-reserved.json';
import enPageAppointment from '../localization/en/page.appointment.json';
import enPageCode from '../localization/en/page.code.json';
import enPageConfirmation from '../localization/en/page.confirmation.json';
import enPageDetails from '../localization/en/page.details.json';
import enPageEnterInvite from '../localization/en/page.enter-invite.json';
import enPageHealthQuestions from '../localization/en/page.health-questions.json';
import enPageHistory from '../localization/en/page.history.json';
import enPageInsurance from '../localization/en/page.insurance.json';
import enPageInvalidInvite from '../localization/en/page.invalid-invite.json';
import enPageInviteDeclined from '../localization/en/page.invite-declined.json';
import enPageInviteExpired from '../localization/en/page.invite-expired.json';
import enPageInviteLocked from '../localization/en/page.invite-locked.json';
import enPageMedications from '../localization/en/page.medications.json';
import enPagePreferenceQuestions from '../localization/en/page.preference-questions.json';
import enPagePrivacy from '../localization/en/page.privacy.json';
import enPageSpecialist from '../localization/en/page.specialist.json';
import enPageStart from '../localization/en/page.start.json';
import enPageWelcome from '../localization/en/page.welcome.json';
import hiCommon from '../localization/hi/common.json';
import hiPageAppointmentReserved from '../localization/hi/page.appointment-reserved.json';
import hiPageAppointment from '../localization/hi/page.appointment.json';
import hiPageCode from '../localization/hi/page.code.json';
import hiPageConfirmation from '../localization/hi/page.confirmation.json';
import hiPageDetails from '../localization/hi/page.details.json';
import hiPageEnterInvite from '../localization/hi/page.enter-invite.json';
import hiPageHealthQuestions from '../localization/hi/page.health-questions.json';
import hiPageHistory from '../localization/hi/page.history.json';
import hiPageInsurance from '../localization/hi/page.insurance.json';
import hiPageInvalidInvite from '../localization/hi/page.invalid-invite.json';
import hiPageInviteDeclined from '../localization/hi/page.invite-declined.json';
import hiPageInviteExpired from '../localization/hi/page.invite-expired.json';
import hiPageInviteLocked from '../localization/hi/page.invite-locked.json';
import hiPageMedications from '../localization/hi/page.medications.json';
import hiPagePreferenceQuestions from '../localization/hi/page.preference-questions.json';
import hiPagePrivacy from '../localization/hi/page.privacy.json';
import hiPageSpecialist from '../localization/hi/page.specialist.json';
import hiPageStart from '../localization/hi/page.start.json';
import hiPageWelcome from '../localization/hi/page.welcome.json';
import miCommon from '../localization/mi/common.json';
import miPageAppointmentReserved from '../localization/mi/page.appointment-reserved.json';
import miPageAppointment from '../localization/mi/page.appointment.json';
import miPageCode from '../localization/mi/page.code.json';
import miPageConfirmation from '../localization/mi/page.confirmation.json';
import miPageDetails from '../localization/mi/page.details.json';
import miPageEnterInvite from '../localization/mi/page.enter-invite.json';
import miPageHealthQuestions from '../localization/mi/page.health-questions.json';
import miPageHistory from '../localization/mi/page.history.json';
import miPageInsurance from '../localization/mi/page.insurance.json';
import miPageInvalidInvite from '../localization/mi/page.invalid-invite.json';
import miPageInviteDeclined from '../localization/mi/page.invite-declined.json';
import miPageInviteExpired from '../localization/mi/page.invite-expired.json';
import miPageInviteLocked from '../localization/mi/page.invite-locked.json';
import miPageMedications from '../localization/mi/page.medications.json';
import miPagePreferenceQuestions from '../localization/mi/page.preference-questions.json';
import miPagePrivacy from '../localization/mi/page.privacy.json';
import miPageSpecialist from '../localization/mi/page.specialist.json';
import miPageStart from '../localization/mi/page.start.json';
import miPageWelcome from '../localization/mi/page.welcome.json';
import smCommon from '../localization/sm/common.json';
import smPageAppointmentReserved from '../localization/sm/page.appointment-reserved.json';
import smPageAppointment from '../localization/sm/page.appointment.json';
import smPageCode from '../localization/sm/page.code.json';
import smPageConfirmation from '../localization/sm/page.confirmation.json';
import smPageDetails from '../localization/sm/page.details.json';
import smPageEnterInvite from '../localization/sm/page.enter-invite.json';
import smPageHealthQuestions from '../localization/sm/page.health-questions.json';
import smPageHistory from '../localization/sm/page.history.json';
import smPageInsurance from '../localization/sm/page.insurance.json';
import smPageInvalidInvite from '../localization/sm/page.invalid-invite.json';
import smPageInviteDeclined from '../localization/sm/page.invite-declined.json';
import smPageInviteExpired from '../localization/sm/page.invite-expired.json';
import smPageInviteLocked from '../localization/sm/page.invite-locked.json';
import smPageMedications from '../localization/sm/page.medications.json';
import smPagePreferenceQuestions from '../localization/sm/page.preference-questions.json';
import smPagePrivacy from '../localization/sm/page.privacy.json';
import smPageSpecialist from '../localization/sm/page.specialist.json';
import smPageStart from '../localization/sm/page.start.json';
import smPageWelcome from '../localization/sm/page.welcome.json';
import zhCommon from '../localization/zh/common.json';
import zhPageAppointmentReserved from '../localization/zh/page.appointment-reserved.json';
import zhPageAppointment from '../localization/zh/page.appointment.json';
import zhPageCode from '../localization/zh/page.code.json';
import zhPageConfirmation from '../localization/zh/page.confirmation.json';
import zhPageDetails from '../localization/zh/page.details.json';
import zhPageEnterInvite from '../localization/zh/page.enter-invite.json';
import zhPageHealthQuestions from '../localization/zh/page.health-questions.json';
import zhPageHistory from '../localization/zh/page.history.json';
import zhPageInsurance from '../localization/zh/page.insurance.json';
import zhPageInvalidInvite from '../localization/zh/page.invalid-invite.json';
import zhPageInviteDeclined from '../localization/zh/page.invite-declined.json';
import zhPageInviteExpired from '../localization/zh/page.invite-expired.json';
import zhPageInviteLocked from '../localization/zh/page.invite-locked.json';
import zhPageMedications from '../localization/zh/page.medications.json';
import zhPagePreferenceQuestions from '../localization/zh/page.preference-questions.json';
import zhPagePrivacy from '../localization/zh/page.privacy.json';
import zhPageSpecialist from '../localization/zh/page.specialist.json';
import zhPageStart from '../localization/zh/page.start.json';
import zhPageWelcome from '../localization/zh/page.welcome.json';

const RESOURCES = {
  en: {
    common: enCommon,
    'page.appointment-reserved': enPageAppointmentReserved,
    'page.appointment': enPageAppointment,
    'page.code': enPageCode,
    'page.confirmation': enPageConfirmation,
    'page.details': enPageDetails,
    'page.enter-invite': enPageEnterInvite,
    'page.health-questions': enPageHealthQuestions,
    'page.history': enPageHistory,
    'page.insurance': enPageInsurance,
    'page.invalid-invite': enPageInvalidInvite,
    'page.invite-declined': enPageInviteDeclined,
    'page.invite-expired': enPageInviteExpired,
    'page.invite-locked': enPageInviteLocked,
    'page.medications': enPageMedications,
    'page.preference-questions': enPagePreferenceQuestions,
    'page.privacy': enPagePrivacy,
    'page.specialist': enPageSpecialist,
    'page.start': enPageStart,
    'page.welcome': enPageWelcome,
  },
  hi: {
    common: hiCommon,
    'page.appointment-reserved': hiPageAppointmentReserved,
    'page.appointment': hiPageAppointment,
    'page.code': hiPageCode,
    'page.confirmation': hiPageConfirmation,
    'page.details': hiPageDetails,
    'page.enter-invite': hiPageEnterInvite,
    'page.health-questions': hiPageHealthQuestions,
    'page.history': hiPageHistory,
    'page.insurance': hiPageInsurance,
    'page.invalid-invite': hiPageInvalidInvite,
    'page.invite-declined': hiPageInviteDeclined,
    'page.invite-expired': hiPageInviteExpired,
    'page.invite-locked': hiPageInviteLocked,
    'page.medications': hiPageMedications,
    'page.preference-questions': hiPagePreferenceQuestions,
    'page.privacy': hiPagePrivacy,
    'page.specialist': hiPageSpecialist,
    'page.start': hiPageStart,
    'page.welcome': hiPageWelcome,
  },
  mi: {
    common: miCommon,
    'page.appointment-reserved': miPageAppointmentReserved,
    'page.appointment': miPageAppointment,
    'page.code': miPageCode,
    'page.confirmation': miPageConfirmation,
    'page.details': miPageDetails,
    'page.enter-invite': miPageEnterInvite,
    'page.health-questions': miPageHealthQuestions,
    'page.history': miPageHistory,
    'page.insurance': miPageInsurance,
    'page.invalid-invite': miPageInvalidInvite,
    'page.invite-declined': miPageInviteDeclined,
    'page.invite-expired': miPageInviteExpired,
    'page.invite-locked': miPageInviteLocked,
    'page.medications': miPageMedications,
    'page.preference-questions': miPagePreferenceQuestions,
    'page.privacy': miPagePrivacy,
    'page.specialist': miPageSpecialist,
    'page.start': miPageStart,
    'page.welcome': miPageWelcome,
  },
  sm: {
    common: smCommon,
    'page.appointment-reserved': smPageAppointmentReserved,
    'page.appointment': smPageAppointment,
    'page.code': smPageCode,
    'page.confirmation': smPageConfirmation,
    'page.details': smPageDetails,
    'page.enter-invite': smPageEnterInvite,
    'page.health-questions': smPageHealthQuestions,
    'page.history': smPageHistory,
    'page.insurance': smPageInsurance,
    'page.invalid-invite': smPageInvalidInvite,
    'page.invite-declined': smPageInviteDeclined,
    'page.invite-expired': smPageInviteExpired,
    'page.invite-locked': smPageInviteLocked,
    'page.medications': smPageMedications,
    'page.preference-questions': smPagePreferenceQuestions,
    'page.privacy': smPagePrivacy,
    'page.specialist': smPageSpecialist,
    'page.start': smPageStart,
    'page.welcome': smPageWelcome,
  },
  zh: {
    common: zhCommon,
    'page.appointment-reserved': zhPageAppointmentReserved,
    'page.appointment': zhPageAppointment,
    'page.code': zhPageCode,
    'page.confirmation': zhPageConfirmation,
    'page.details': zhPageDetails,
    'page.enter-invite': zhPageEnterInvite,
    'page.health-questions': zhPageHealthQuestions,
    'page.history': zhPageHistory,
    'page.insurance': zhPageInsurance,
    'page.invalid-invite': zhPageInvalidInvite,
    'page.invite-declined': zhPageInviteDeclined,
    'page.invite-expired': zhPageInviteExpired,
    'page.invite-locked': zhPageInviteLocked,
    'page.medications': zhPageMedications,
    'page.preference-questions': zhPagePreferenceQuestions,
    'page.privacy': zhPagePrivacy,
    'page.specialist': zhPageSpecialist,
    'page.start': zhPageStart,
    'page.welcome': zhPageWelcome,
  },
};

export default RESOURCES;
